import React from 'react';
import { makeStyles } from '@material-ui/core';
import { IconStars } from './Icons';
import { COLOR_BLACK, COLOR_WHITE } from '../../../../colors';

const useStyles = makeStyles((theme)=> ({
    restaurantInfographicWrap: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: '0 24px 64px',
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 500,
        justifyContent: 'center',
    },
    countContainer: {
        textAlign: 'center',
    },
    byCategoryContainer: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    count: {
        fontSize: 96,
        lineHeight: '128px',
        fontWeight: 900,
    },
    subheading: {
        position: 'relative',
        fontSize: 20,
        lineHeight: '28px',
        fontWeight: 900,
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
        margin: '0 auto',
        padding: '10px 0',
        zIndex: 1,
        textAlign: 'center',

        '&::before': {
            position: 'absolute',
            left: -25,
            top: 0,
            content: "''",
            height: 48,
            width: 48,
            backgroundColor: COLOR_BLACK,
            borderTopLeftRadius: 52,
            borderBottomLeftRadius: 52,
            zIndex: -1,
        },

        '&::after': {
            position: 'absolute',
            right: -25,
            top: 0,
            content: "''",
            height: 48,
            width: 48,
            backgroundColor: COLOR_BLACK,
            borderTopRightRadius: 52,
            borderBottomRightRadius: 52,
            zIndex: -1,
        },
    },
    restaurantsList: {
        marginTop: 20,
    },
    restaurantsListItem: {
        display: 'flex',
        flex: 1,
        justifyContent: 'start center',
        marginBottom: 8,
        '&:last-of-type': {
            marginBottom: 0,
        }
    },
    category: {
        fontWeight: 900,
        marginRight: 6,
    },
    dottedLine: {
        display: 'flex',
        flex: 1,
        borderTop: `4px dotted ${COLOR_BLACK}`,
        marginTop: 20,
    },
    categoryCount: {
        fontWeight: 500,
        marginLeft: 6,
    }
}));

export function RestaurantsInfographic({
    restaurants,
}) {
    const classes = useStyles();
    const { by_category: byCategoryStr, count } = restaurants || {};
    const by_category = (byCategoryStr || '')
        .split(',')
        .filter(Boolean)
        .map((v)=> {
            const [category, count] = v.split(':');
            return { category, count };
        }).slice(0, 5);
    return (
        <div className={classes.restaurantInfographicWrap}>
            <div className={classes.countContainer}>
                <div className={classes.count}>{count || '-'}</div>
                <IconStars />
                <div style={{margin: '16px auto 18px'}}>Restaurants within 5 miles</div>
            </div>

            {by_category?.length > 0 && (<div className={classes.byCategoryContainer}>
                <div className={classes.subheading}>
                    <div>Top good eats by category</div>
                </div>
                <div className={classes.restaurantsList}>
                    {by_category.filter(Boolean).map((restaurant)=> (
                        <div className={classes.restaurantsListItem}
                            key={restaurant.category}
                        >
                            <div className={classes.category}>{restaurant.category}</div>
                            <div className={classes.dottedLine}></div>
                            <div className={classes.categoryCount}>{restaurant.count}</div>
                        </div>
                    ))}
                </div>
            </div>)}
        </div>
    );
}
